import path from 'ramda/src/path'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

export default (state, { moduleId, moduleKey }) => {
	const nextStepSelectorFn = path([moduleId, 'nextStepIdSelectorFn'], moduleDescriptions)
	return nextStepSelectorFn(state, moduleKey)
}
